<script setup>
  defineProps({
    text: String,
    isTab: {
      type: Boolean,
      default: false
    }
  })
</script>

<template>
  <section
    class="element-text"
    :class="isTab ? 'tab' : '~mt-20/28 max-w-screen-2xl mx-auto px-6'"
  >
    <div
      v-html="text"
    />
  </section>
</template>

<style lang="scss" scoped>
  .element-text {
    h1 {
      @apply ~text-3xl/5xl max-w-screen-2xl mx-auto font-normal mb-4;
      line-height: 1.4 !important;
    }
    p {
      @apply ~text-sm/base text-body;
    }
  }
</style>
